import { Link } from 'react-router-dom';

const strengths = [
  { icon: 'ri-fire-line', title: 'Passionate Leadership', desc: 'Led by experienced founders deeply dedicated to our mission and the communities we serve.' },
  { icon: 'ri-bar-chart-2-line', title: 'Measurable Outcomes', desc: 'High-impact programs with clear, trackable results and transparent reporting.' },
  { icon: 'ri-leaf-line', title: 'Sustainable Strategy', desc: 'Long-term vision for lasting change, not just short-term interventions.' },
  { icon: 'ri-shield-check-line', title: 'Transparent Governance', desc: 'Structured systems ensure accountability and trust with all stakeholders.' },
  { icon: 'ri-map-pin-user-line', title: 'Community-Centred', desc: 'Approaches tailored to local needs, culture, and context across Nigeria and Africa.' },
  { icon: 'ri-links-line', title: 'Strategic Partnerships', desc: 'Strong alliances with medical institutions, NGOs, and government bodies.' },
];

export default function WhyIkiruSection() {
  return (
    <section className="py-24 bg-[#FAF7FC]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-xs font-semibold uppercase tracking-[4px] text-[#7B2D8B] mb-4 block">Why Partner With Us</span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-6">
              Our Unwavering <span className="text-[#7B2D8B]">Commitment</span>
            </h2>
            <p className="text-gray-500 leading-relaxed mb-8">
              IKIRU stands as a beacon of hope, driven by a profound commitment to those living with epilepsy. Our strength lies in our principled approach and impactful programs. Join us in giving hope and life to millions living with epilepsy across Nigeria and Africa.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {strengths.map((s) => (
                <div key={s.title} className="flex gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#7B2D8B]/10 shrink-0 mt-0.5">
                    <i className={`${s.icon} text-[#7B2D8B] text-base`}></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-800 text-sm mb-1">{s.title}</div>
                    <div className="text-gray-500 text-xs leading-relaxed">{s.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/get-involved"
                className="px-7 py-3.5 rounded-full bg-[#7B2D8B] text-white font-semibold text-sm hover:bg-[#6a2578] transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                Become a Partner
              </Link>
              <Link
                to="/get-involved"
                className="px-7 py-3.5 rounded-full border-2 border-[#7B2D8B] text-[#7B2D8B] font-semibold text-sm hover:bg-[#7B2D8B]/5 transition-colors cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-2"
              >
                Make a Donation <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden h-[520px]">
              <img
                src="https://readdy.ai/api/search-image?query=IKIRU%20epilepsy%20foundation%20team%20of%20African%20volunteers%20and%20healthcare%20workers%20working%20together%20outdoors%2C%20community%20outreach%20event%2C%20colorful%20branded%20t-shirts%2C%20smiling%20and%20engaged%2C%20warm%20sunlight%2C%20authentic%20African%20community%20setting%2C%20hopeful%20and%20energetic%20atmosphere&width=700&height=900&seq=why001&orientation=portrait"
                alt="IKIRU team in action"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute top-6 -left-6 bg-white rounded-2xl p-5 border border-purple-100 max-w-[200px]">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#7B2D8B]/10">
                  <i className="ri-award-line text-[#7B2D8B] text-sm"></i>
                </div>
                <span className="font-bold text-gray-900 text-sm">Trusted NGO</span>
              </div>
              <p className="text-gray-500 text-xs leading-snug">Registered & operating across Nigeria with full transparency</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
